import React, { useContext, useState } from 'react'
import {
  ChangePresentContext,
  EventMetaContext,
  PostEventAnalysisContext,
  ShiftContext,
} from '../SingleEvent'
import BigModal from '../../../../components/Modals/BigModal'
import TextField from '@mui/material/TextField'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

const PEAStaffFeedback = () => {
  const { eventMeta } = useContext(EventMetaContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  const { shifts } = useContext(ShiftContext)
  const { postEventAnalysis, setPostEventAnalysis } = useContext(
    PostEventAnalysisContext
  )
  const [openStaffFeedbacks, setOpenStaffFeedbacks] = useState(false)

  const shiftsWithFeedback = shifts
    ? shifts?.filter((shift) => shift?.staffFeedback)
    : []

  const hasFeedback = shiftsWithFeedback.length > 0

  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} gap={1}>
      <TextField
        multiline
        minRows={2}
        value={postEventAnalysis?.staffFeedback}
        fullWidth
        onChange={(e) => {
          setPostEventAnalysis((prev) => ({
            ...prev,
            staffFeedback: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        label="Staff Feedback"
        InputLabelProps={{ shrink: !!postEventAnalysis?.staffFeedback }}
      />
      {hasFeedback && (
        <Tooltip title="View Shift Feedback">
          <Button
            onClick={() => setOpenStaffFeedbacks(true)}
            variant="contained"
            color="anMainBlue"
          >
            <Stack direction="row" gap={1} alignItems="center">
              <VisibilityIcon />
              <Typography sx={{ display: { xs: 'inherit', lg: 'none' } }}>
                View Shift Feedback
              </Typography>
            </Stack>
          </Button>
        </Tooltip>
      )}
      <BigModal
        open={openStaffFeedbacks}
        onClose={() => setOpenStaffFeedbacks(false)}
      >
        <Stack gap={1}>
          <Typography variant="title2">
            Staff Shift Feedback for {eventMeta.title}
          </Typography>
          {shiftsWithFeedback.map((shift) => (
            <Stack direction="row" gap={1} key={shift._id} alignItems="center">
              <Avatar
                src={shift.assignedTo?.userAccount?.photograph}
                sx={{ height: 24, width: 24 }}
              />
              <Typography
                variant="title2"
                fontSize="0.9rem"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {shift.assignedTo.userAccount.firstName +
                  ' ' +
                  shift.assignedTo.userAccount.lastName}
              </Typography>
              <Typography variant="title2" fontSize="0.9rem" color="#181818">
                {shift.staffFeedback}
              </Typography>
              <Button
                size="small"
                color="anPurple"
                onClick={() => {
                  setPostEventAnalysis((prev) => ({
                    ...prev,
                    staffFeedback: prev?.staffFeedback
                      ? `${prev.staffFeedback}\n${shift.staffFeedback}`
                      : shift.staffFeedback,
                  }))
                  setOpenStaffFeedbacks(false)
                  !changesPresent && setChangesPresent(true)
                }}
                variant="contained"
              >
                Copy to PEA
              </Button>
            </Stack>
          ))}
        </Stack>
      </BigModal>
    </Stack>
  )
}

export default React.memo(PEAStaffFeedback)
